import React, { useEffect, useState } from "react";
import StyleWrapper from "./style";
import { useTranslation } from "react-i18next";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import CalendarIcon from "assets/images/icons/components/CalendarIcon";
import motorDriveLogo from "../../../../../../assets/images/motor-drive-logo.png";
import { useDispatch, useSelector } from "react-redux";
import { changeIsDriverSelected } from "redux/actions/motorActions";

const PolicyDetail = (props) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dispatch = useDispatch();
  const { driverRegistered } = useSelector((state) => state.motor);
  const { data, sendValues, hideWorkshop, selectedProposal, motorDrive, setMotorDrive } = props;
  const [policyDate, setPolicyDate] = useState(null);
  const [repairType, setRepairType] = useState(
    data?.agencyRepairRequired === "Y"
      ? { name: currentLanguage == "en" ? "Agency" : "وكالة", code: "Y" }
      : { name: currentLanguage == "en" ? "Workshop" : "الورش", code: "N" }
  );
  const [policyApply, setPolicyApply] = useState(true);

  const repairTypeList = [
    { name: currentLanguage == "en" ? "Workshop" : "الورش", code: "N" },
    { name: currentLanguage == "en" ? "Agency" : "وكالة", code: "Y" },
  ];

  useEffect(() => {
    setRepairType(
      data?.agencyRepairRequired === "Y"
        ? { name: currentLanguage == "en" ? "Agency" : "وكالة", code: "Y" }
        : { name: currentLanguage == "en" ? "Workshop" : "الورش", code: "N" }
    );
  }, [data]);

  const maxDate = new Date();
  const minDate = new Date();
  minDate.setDate(maxDate.getDate() + 1);
  maxDate.setDate(maxDate.getDate() + 45);

  const valuesChanged = (value) => {
    const data = {
      agencyRepairRequired: repairType?.code,
      requiredInceptionDate: policyDate,
      applyAll: policyApply,
    };

    sendValues({ ...data, ...value });
  };

  const handlechange = (e) => {
    setMotorDrive(e.target.checked);
    dispatch(
      changeIsDriverSelected(e.target.checked)
    );
  }

  return (
    <StyleWrapper>
      <div className={"policy-detail"}>
        <div className="policy-box">
          <div className="row policy-row">
            <div className="col-sm-12 col-md-12 col-lg-6 columnpolicy py-2">
              <label htmlFor="" className="mb-3"> {t("POLICY.POLICY_DATE")} </label>
              <Calendar
                id="icon"
                value={policyDate}
                onChange={(e) => {
                  setPolicyDate(e.value);
                  valuesChanged({ requiredInceptionDate: e.value });
                }}
                showIcon
                iconPos="left"
                icon={<CalendarIcon color={props.businessColor || "#6B47F5"} />}
                placeholder={t("POLICY.POLICY_DATE")}
                maxDate={maxDate}
                minDate={minDate}
                className={`fm-tawuniya normal-inception ${!policyDate&& 'red-inception'}`}
              />
              {!policyDate && <span style={{ color: 'red' ,marginTop:"8px"}}>{t("SALES.pole-8")}</span>}
            </div>
            {!hideWorkshop && (
              <div className="col-sm-12 col-md-12 col-lg-6 columnpolicy py-2 pb-0">
                <label htmlFor="repair">{t("POLICY.REPAIR_TYPE")}</label>
                <span className="">
                  <Dropdown
                    inputId="repair"
                    value={repairType}
                    options={repairTypeList}
                    onChange={(e) => {
                      setRepairType(e.value);
                      valuesChanged({ agencyRepairRequired: e.value.code });
                    }}
                    optionLabel="name"
                    placeholder={t("POLICY.REPAIR_TYPE")}
                  />
                </span>
                {/* <div className="apply-all mt-2">
                <InputSwitch
                  checked={policyApply}
                  onChange={(e) => {setPolicyApply(e.value); valuesChanged({applyAll:e.value})}}
                />
                <label>{t("POLICY.POLICY_APPLY")}</label>
              </div> */}
              </div>
            )}
            <br />
            <small id="username1-help" className="  d-inline-flex align-items-center mt-2">
              <i className="pi pi-info-circle mx-2 block" />
              <label className="block" htmlFor="">
                {t("POLICY.POLICY_APPLIED")}
              </label>
            </small>
            {selectedProposal &&
              (selectedProposal === "PRMotorImtiazeSP" ||
                selectedProposal === "PRMotorImtiazeCO") &&
              driverRegistered.isDriverRegistered === false && (
                <div className="motor-drive">
                  <div className="motor-drive-2">
                    {/* <input
                      type="checkbox"
                      name="motorDriveCheckbox"
                      //value={motorDrive}
                      onChange={handlechange}
                      checked={motorDrive}
                    /> */}
                    <div>
                      {/* <h4 className="motor-drive-title">{t("POLICY.motor-drive-title-1")}</h4> */}
                      <h4 className="motor-drive-title flex-direction-column">
                        <p>
                          {t("POLICY.motor-drive-title-2")}
                          <span> 
                          <bdi> {selectedProposal === "PRMotorImtiazeSP" && "500"} {selectedProposal === "PRMotorImtiazeCO" && "1000"} {t("POLICY.motor-drive-title-3")}</bdi>
                          </span>
                          {t("POLICY.motor-drive-title-4")}
                          {!props.businessLine && (<>
                          &nbsp;<a href="https://www.tawuniya.com/en/individuals/loyalty-program/drive" target="_blank" rel="noreferrer">
                              {t("POLICY.motor-drive-title-5")}
                            </a>
                          </>)}
                        </p>
                      </h4>
                    </div>
                  </div>
                  <img height={50} src={motorDriveLogo} alt="motorDriveLogo" />
                </div>
              )}
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default PolicyDetail;
